import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['createFromTemplateModalVisible'] = false,
  action: Action,
): RootState['createFromTemplateModalVisible'] {
  switch (action.type) {
    case 'CREATE_FROM_TEMPLATE_MODAL_VISIBLE_SET': {
      return action.payload
    }

    default:
      return state
  }
}
